import * as yup from 'common/yup';
import {CONTEXT_SEND_PARAMETER} from 'common/yup/constants';
import {isBoolean} from 'lodash';

export const SftpPasswordPoliciesNames = {
   minNumChars: 'minNumChars',

   _UPPERCASE_CHECK: 'UPPERCASE_CHECK',
   minNumUpper: 'minNumUpper',

   _LOWERCASE_CHECK: 'LOWERCASE_CHECK',
   minNumLower: 'minNumLower',

   _NUMERIC_CHECK: 'NUMERIC_CHECK',
   minNumNumeric: 'minNumNumeric',

   _SPECIAL_CHECK: 'SPECIAL_CHECK',
   minNumSpecial: 'minNumSpecial',

   // _BE_UPDATED_EVERY_CHECK: 'BE_UPDATED_EVERY_CHECK',
   // passwordUpdateInterval: 'passwordUpdateInterval',
} as const;

const SftpPasswordPoliciesCore = yup.object({
   minNumChars: yup.number(),
   minNumUpper: yup.number(),
   minNumLower: yup.number(),
   minNumNumeric: yup.number(),
   minNumSpecial: yup.number(),
   // passwordUpdateInterval: yup.number(),
});

const _SftpPasswordPoliciesToSend = SftpPasswordPoliciesCore.transform(function (val, origin) {
   if (!isBoolean(val[SftpPasswordPoliciesNames._UPPERCASE_CHECK])) {
      return val;
   }

   val[SftpPasswordPoliciesNames.minNumUpper] = val[SftpPasswordPoliciesNames._UPPERCASE_CHECK]
      ? val[SftpPasswordPoliciesNames.minNumUpper]
      : 0;
   val[SftpPasswordPoliciesNames.minNumLower] = val[SftpPasswordPoliciesNames._LOWERCASE_CHECK]
      ? val[SftpPasswordPoliciesNames.minNumLower]
      : 0;
   val[SftpPasswordPoliciesNames.minNumNumeric] = val[SftpPasswordPoliciesNames._NUMERIC_CHECK]
      ? val[SftpPasswordPoliciesNames.minNumNumeric]
      : 0;
   val[SftpPasswordPoliciesNames.minNumSpecial] = val[SftpPasswordPoliciesNames._SPECIAL_CHECK]
      ? val[SftpPasswordPoliciesNames.minNumSpecial]
      : 0;
   // val[SftpPasswordPoliciesNames.passwordUpdateInterval] = val[
   //    SftpPasswordPoliciesNames._BE_UPDATED_EVERY_CHECK
   // ]
   //    ? val[SftpPasswordPoliciesNames.passwordUpdateInterval]
   //    : 0;

   delete val[SftpPasswordPoliciesNames._UPPERCASE_CHECK];
   delete val[SftpPasswordPoliciesNames._LOWERCASE_CHECK];
   delete val[SftpPasswordPoliciesNames._NUMERIC_CHECK];
   delete val[SftpPasswordPoliciesNames._SPECIAL_CHECK];
   // delete val[SftpPasswordPoliciesNames._BE_UPDATED_EVERY_CHECK];

   return val;
});

const _SftpPasswordPoliciesWithHelpers = SftpPasswordPoliciesCore.shape({
   [SftpPasswordPoliciesNames._UPPERCASE_CHECK]: yup.boolean(),
   [SftpPasswordPoliciesNames._LOWERCASE_CHECK]: yup.boolean(),
   [SftpPasswordPoliciesNames._NUMERIC_CHECK]: yup.boolean(),
   [SftpPasswordPoliciesNames._SPECIAL_CHECK]: yup.boolean(),
   // [SftpPasswordPoliciesNames._BE_UPDATED_EVERY_CHECK]: yup.boolean(),
}).transform(function (val, origin) {
   if (isBoolean(val[SftpPasswordPoliciesNames._UPPERCASE_CHECK])) {
      return val;
   }

   val[SftpPasswordPoliciesNames._UPPERCASE_CHECK] = val[SftpPasswordPoliciesNames.minNumUpper] > 0;
   val[SftpPasswordPoliciesNames._LOWERCASE_CHECK] = val[SftpPasswordPoliciesNames.minNumLower] > 0;
   val[SftpPasswordPoliciesNames._NUMERIC_CHECK] = val[SftpPasswordPoliciesNames.minNumNumeric] > 0;
   val[SftpPasswordPoliciesNames._SPECIAL_CHECK] = val[SftpPasswordPoliciesNames.minNumSpecial] > 0;
   // val[SftpPasswordPoliciesNames._BE_UPDATED_EVERY_CHECK] =
   //    val[SftpPasswordPoliciesNames.passwordUpdateInterval] > 0;

   return val;
});

export const SftpPasswordPolicies = SftpPasswordPoliciesCore.when(CONTEXT_SEND_PARAMETER, {
   is: true,
   then: _SftpPasswordPoliciesToSend,
   otherwise: _SftpPasswordPoliciesWithHelpers,
});
export type ISftpPasswordPolicies = yup.InferType<typeof _SftpPasswordPoliciesWithHelpers>;
